import { render, staticRenderFns } from "./AppealDetailDialog.vue?vue&type=template&id=c71c38fa&"
import script from "./AppealDetailDialog.vue?vue&type=script&lang=js&"
export * from "./AppealDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports